import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './assets/flaticon.css'
import 'font-awesome/css/font-awesome.min.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Home from "./components/home";
import ReactGA from "react-ga4";
import Policy from "./components/policy";
import Contact from "./components/contact";
ReactGA.initialize("G-2Y2SR9V7R4");
ReactGA.send(window.location.pathname);

const routing = (

        <BrowserRouter>
            <Routes>

                <Route path='/' element={<Home />} />

                <Route path='/privacy-policy' element={<Policy />} />
                <Route path='/data-settings' element={<Contact />} />
                  </Routes>
        </BrowserRouter>

)


ReactDOM.render([routing], document.getElementById('root'))

